import React from "react";

function Navbar() {
  return (
    <nav className="navbar">
      <div className="logo">SimpliConnect</div>
      <ul>
        <li>Home</li>
        <li>About Us</li>
        <li>Why Choose Us</li>
        <li>Services</li>
        <li>Contact</li>
      </ul>
      <button className="contact-btn">Contact Us</button>
    </nav>
  );
}

export default Navbar;